// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyChxURRMVkGvLvMSKQobwO7upjV9tLSAbc",
  authDomain: "cognitivegames-3975a.firebaseapp.com",
  databaseURL: "https://cognitivegames-3975a-default-rtdb.firebaseio.com",
  projectId: "cognitivegames-3975a",
  storageBucket: "cognitivegames-3975a.firebasestorage.app",
  messagingSenderId: "42690870815",
  appId: "1:42690870815:web:a64b83db2e1075d68e5f2a",
  measurementId: "G-9P4EZ9NVPE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
export const db = getDatabase(app);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Initialize Analytics
export const analytics = getAnalytics(app);

// Firebase is enabled with your actual configuration
export const isFirebaseEnabled = true;

export default app;